// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_b1J","cls2":"JournalSubscriptionPage-cls2_Rs_ JournalSubscriptionPage-cls1_b1J"};